module.exports = __webpack_public_path__ + "img/87.0e3ba316.jpg";